import styled from "styled-components";
import theme from "../../Styles/theme";

export const ButtonContainer = styled.button`
  color: ${theme.colors.dark};
  background-color: ${theme.colors.light};
    display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: max(1.2vw, 10px);

  
  border-radius: 0.25rem;
  padding: 1vh 2vw;
`;

export const ModalContainer = styled.div`
  height: 30vh;
`;

export const TableContainer = styled.section`
  margin: auto;

  display: block;

  width: 100%;
  overflow-x/*(eixo x)*/: auto; /*Agora quando necessário a rolagem da tabela é permitida(funcionamento para o mobile)*/

  margin-bottom: 10px;
  overflow-y: scroll;
  height: 100%;
  &::-webkit-scrollbar {
    width: 0.6vw;
    height: 0.6vw;
  }
  &::-webkit-scrollbar-thumb {
    background-color: ${theme.colors.dark}; /* color of the scroll thumb */
    border-radius: 0.25rem; /* roundness of the scroll thumb */
    height: 2px;
  }
`;

interface PrefeituraButtonProps {
    focus: boolean;
  }
export const ItemPrefeitura = styled.button<PrefeituraButtonProps>`
  display: grid;
  grid-template-columns: 1fr 4fr;
  align-items: center;

  background-color: ${({ focus }) =>
    focus ? theme.colors.darkGrey : theme.colors.light};;
  &:hover {
    opacity: 0.8;
  }

  margin-bottom: 2vh;

  padding: 1vh 2vw;

  border-radius: 0.25rem;
`;

export const LogoPrefeitura = styled.img`
  width: max(3vw, 20px);
  height: max(3vw, 20px);
`;

export const ImageHelper = styled.div`
  display: flex;
  align-items: flex-start;
`;

export const TitlePrefeitura = styled.h2`
  font-size: max(8px, 1vw);
  color: ${theme.colors.dark};
  margin-left: 1vw;
  white-space: nowrap;
`;


export const PrefeituraButton = styled.button`

  margin: auto;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;
